import React, { useEffect, useMemo, useState } from "react";
import "./BranchLedgerList.css";
import { Edit, Trash } from "lucide-react";
import axios from "axios";
import toast from "react-hot-toast";

const BranchLedgerList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [branch, setBranch] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [ledgers, setLedgers] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);

  const rowsPerPage = 20;
  const superAdminId = localStorage.getItem("adminuserId");

  // Dynamic State Data
  const [branchLedgers, setBranchLedgers] = useState([]);

  // Form Data
  const [formData, setFormData] = useState({
    branch: "",
    ledger: "",
    openingBalance: "",
  });

  const fetchBranchs = async () => {
    // console.log(superAdminId);
    try {
      const res = await axios.get(`https://payyug.in/api/get-branch`, {
        params: {
          SuperAdminId: superAdminId,
          limit: "all",
        },
      });

      console.log("branch data", res);
      setBranch(res.data.branches || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchLedgers = async (page = currentPage) => {
    // console.log(superAdminId);
    try {
      const res = await axios.get(`https://payyug.in/api/ledger/getall`, {
        params: {
          superAdminId,
        },
      });

      // console.log("response data", res);

      setLedgers(res.data.rows || []);
      setTotalPages(res.data.totalPages || 1);
      // setCurrentPage(res.data.currentPage || page);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchBranchLedgers = async (page = currentPage) => {
    // console.log(superAdminId);
    try {
      const res = await axios.get(
        ` https://payyug.in/api/branch-ledger/get-all`,
        {
          params: {
            superAdminId,
            page,
            limit: rowsPerPage,
            status: "Active",
          },
        }
      );

      // console.log("response data", res);

      setBranchLedgers(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
      // setCurrentPage(res.data.currentPage || page);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const createUpdate = async (e) => {
    e.preventDefault();
    console.log("formdata values are", formData);
    var payload = {
      branch_id: selectedBranch.id,
      ledger_id: selectedLedger.id,
      openingAmt: Number(formData.openingBalance),
      superAdminId: superAdminId,
    };

    try {
      if (editIndex !== null) {
        // ===================== UPDATE ======================
        await axios.put(
          `https://payyug.in/api/branch-ledger/update/${editIndex}`,
          payload
        );
        toast.success("Center updated successfully");
      } else {
        // ===================== CREATE ======================
        await axios.post(`https://payyug.in/api/branch-ledger/create`, payload);

        toast.success("Center created successfully");
      }

      fetchBranchLedgers();
      setModalOpen(false);
    } catch (error) {
      console.log("API Error:", error);
      alert("failed to create Brach ledger", error.code);
      toast.error(error?.response?.data?.error || "Failed to save");
      setModalOpen(false);
    }
  };

  const handledelete = (id) => async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this center?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`https://payyug.in/api/branch-ledger/delete/${id}`);
      toast.success("Center deleted successfully");
      fetchBranchLedgers();
    } catch (error) {
      toast.error("Failed to delete center");
    }
  };

  useEffect(() => {
    fetchBranchLedgers();
  }, [currentPage]);

  useEffect(() => {
    fetchBranchs();
    fetchLedgers();
  }, []);

  // Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Edit Handler
  // const handleEdit = (item) => {
  //   setEditIndex(item.id);
  //   setFormData(branchLedgers[index]);
  //   setModalOpen(true);
  // };

  const handleEdit = (item) => {
    setEditIndex(item.id);
    setFormData({
      branch: item.branch_id,
      ledger: item.ledger?.id,
      openingBalance: item.openingAmt,
    });
    setModalOpen(true);
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    let data = [...branchLedgers];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    // if (searchQuery.trim()) {
    //   data = data.filter((item) =>
    // item.group.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
    // item.status.toLowerCase().includes(searchQuery.toLowerCase())
    //   );
    // }

    return data;
  }, [branchLedgers, searchQuery]);

  // const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData;
  // .slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage
  // );

  return (
    <>
      <div className="branch-ledger-list-container">
        <h2 className="heading">Branch Ledger List</h2>

        <div className="branch-ledger-list-top-section">
          <input
            type="text"
            placeholder="Search by Group / Type / Status..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <button
            className="add-btn"
            onClick={() => {
              setFormData({ branch: "", ledger: "", openingBalance: "" });
              setEditIndex(null);
              setModalOpen(true);
            }}
          >
            Add New
          </button>
        </div>

        {/* Table */}
        <div className="branch-ledger-list-report-section">
          <table className="branch-ledger-list-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Branch Id</th>
                <th>Ledger</th>
                <th>Opening Balance</th>
                {/* <th>Status</th> */}
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.branch_id}</td>
                    <td>{item.ledger.name}</td>
                    <td>{item.openingAmt}</td>
                    {/* <td>{item.status}</td> */}
                    <td>
                      <button onClick={() => handleEdit(item)}>
                        <Edit size={18} />
                      </button>
                      <Trash
                        className="delete-icon-gl"
                        onClick={handledelete(item.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="branch-ledger-list-pagination-section">
          <div className="branch-ledger-list-pagination-div">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ⬅ Prev
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next ➡
            </button>
          </div>
        </div>

        {/* Modal */}
        {modalOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h2 className="dialog-box-heading">
                {editIndex !== null
                  ? "Edit Branch Ledger"
                  : "Add New Branch Ledger"}
              </h2>

              <form className="dialog-box-form-section" onSubmit={createUpdate}>
                <div className="dialog-box-input-group">
                  <label>Branch Name</label>
                  <select
                    name="branch"
                    value={formData.branch}
                    // onChange={handleChange}>
                    onChange={(e) => {
                      handleChange(e);
                      const group = branch.find(
                        (c) => c.id === Number(e.target.value)
                      );
                      setSelectedBranch(group);
                    }}
                  >
                    <option value="">Select Branch</option>
                    {branch.map((br) => (
                      <option key={br.id} value={br.id}>
                        {br.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="dialog-box-input-group">
                  <label>Ledger Name</label>
                  <select
                    name="ledger"
                    value={formData.ledger}
                    // onChange={handleChange}>
                    onChange={(e) => {
                      handleChange(e);
                      const ledger = ledgers.find(
                        (c) => c.id === Number(e.target.value)
                      );
                      setSelectedLedger(ledger);
                    }}
                  >
                    <option value="">Select Ledger</option>
                    {ledgers.map((lg) => (
                      <option key={lg.id} value={lg.id}>
                        {lg.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="dialog-box-input-group">
                  <label>Opening Balance</label>
                  <input
                    type="text"
                    name="openingBalance"
                    value={formData.openingBalance}
                    onChange={handleChange}
                  />
                </div>

                <div className="dialog-btns">
                  <button type="submit">
                    {editIndex !== null ? "Update" : "Create"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BranchLedgerList;
